import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import firebase from "firebase/compat/app";
import { FileOpener } from "@awesome-cordova-plugins/file-opener/ngx";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule } from "@angular/forms";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "./shared/modules/material/material.module";
import { HeaderComponent } from "./pages/layout/header/header.component";
import { SidebarComponent } from "./pages/layout/sidebar/sidebar.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { SupportComponent } from "./pages/support/support.component";
import { SubscriptionComponent } from "./pages/subscription/subscription.component";
import { ActivityComponent } from "./pages/activity/activity.component";
import { PromotionComponent } from "./pages/promotion/promotion.component";
import { ReportComponent } from "./pages/report/report.component";
import { TitleBarComponent } from "./shared/components/title-bar/title-bar.component";
import { StatCardsComponent } from "./pages/dashboard/stat-cards/stat-cards.component";
import { LoginComponent } from "./pages/auth/login/login.component";
import { ReactiveFormsModule } from "@angular/forms";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { LatestUsersComponent } from "./pages/dashboard/latest-users/latest-users.component";
import { DataTableComponent } from "./shared/components/data-table/data-table.component";
import { LatestCountryListComponent } from "./pages/dashboard/latest-country-list/latest-country-list.component";
import { LatestSupportRequestComponent } from "./pages/support/latest-support-request/latest-support-request.component";
import { UnblockRequestComponent } from "./pages/support/unblock-request/unblock-request.component";
import { AllUsersComponent } from "./pages/dashboard/all-users/all-users.component";
import { AllCountriesComponent } from "./pages/dashboard/all-countries/all-countries.component";
import { AllSupportRequestComponent } from "./pages/support/all-support-request/all-support-request.component";
import { AllUnblockRequestComponent } from "./pages/support/all-unblock-request/all-unblock-request.component";
import { UserProfileComponent } from "./shared/components/user-profile/user-profile.component";
import { LatestAbuseReportComponent } from "./pages/activity/latest-abuse-report/latest-abuse-report.component";
import { LatestDeactivatedAccountComponent } from "./pages/activity/latest-deactivated-account/latest-deactivated-account.component";
import { AllAbuseReportComponent } from "./pages/activity/all-abuse-report/all-abuse-report.component";
import { AllDeactivatedAccountComponent } from "./pages/activity/all-deactivated-account/all-deactivated-account.component";
import { DatePipe } from "@angular/common";
import { AllBusinessInfoComponent } from "./pages/subscription/all-business-info/all-business-info.component";
import { AllEmployeeInfoComponent } from "./pages/subscription/all-employee-info/all-employee-info.component";
import { AllTransactionInfoComponent } from "./pages/subscription/all-transaction-info/all-transaction-info.component";
import { AdminPostComponent } from "./pages/promotion/admin-post/admin-post.component";
import { BusinessPromotionComponent } from "./pages/promotion/business-promotion/business-promotion.component";
import { TargetNotificationComponent } from "./pages/promotion/target-notification/target-notification.component";
import { AdvertisersComponent } from "./pages/promotion/advertisers/advertisers.component";
import { AdminPostCardComponent } from "./shared/components/admin-post-card/admin-post-card.component";
import { AddAdminPostComponent } from "./shared/components/add-admin-post/add-admin-post.component";
import { BusinessPromotionCardComponent } from "./shared/components/business-promotion-card/business-promotion-card.component";
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { AddTargetNotificationComponent } from "./shared/components/add-target-notification/add-target-notification.component";
import { LocationAutocompleteDirective } from "./directive/location-autocomplete.directive";
import { NgImageSliderModule } from "ng-image-slider";
import { AddBuisnessPostComponent } from "./shared/components/add-buisness-post/add-buisness-post.component";
import { CrouselComponent } from "./shared/components/crousel/crousel.component";
import { AdminPostDetailsComponent } from "./shared/components/admin-post-details/admin-post-details.component";
import { CouponsComponent } from "./pages/promotion/coupons/coupons.component";
import { CouponsCardComponent } from "./shared/components/coupons-card/coupons-card.component";
import { AddDiscountComponent } from "./pages/promotion/add-discount/add-discount.component";
import { BusinessesComponent } from "./pages/businesses/businesses.component";
import { DocumentsComponent } from "./pages/businesses/documents/documents.component";
import { BusinessListComponent } from "./pages/businesses/business-list/business-list.component"; // ---------- Important
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { ServicesComponent } from "./pages/businesses/services/services.component";
import { DetailsComponent } from "./pages/businesses/details/details.component";
import { DeactivateBusinessComponent } from "./pages/businesses/deactivate-business/deactivate-business.component";
import { OnlinePaymentsComponent } from "./pages/businesses/online-payments/online-payments.component";
import { CancelVerificationComponent } from "./pages/businesses/documents/cancel-verification/cancel-verification.component";
import { ServiceTemplatesComponent } from "./pages/service-templates/service-templates.component";
import { PaymentsComponent } from "./pages/businesses/online-payments/payments/payments.component";
import { AddServiceComponent } from "./shared/components/add-service/add-service.component";
import { StatusNotesComponent } from "./pages/businesses/online-payments/status-notes/status-notes.component";
import { AddServiceTemplatesComponent } from "./shared/components/add-service-templates/add-service-templates.component";
import { EntityBusinessComponent } from "./pages/dashboard/entity-business/entity-business.component";
import { DisableComponent } from "./pages/businesses/online-payments/disable/disable.component";
import { DeactivateComponent } from "./pages/businesses/online-payments/deactivate/deactivate.component";
import { OnlineTransactionsComponent } from "./pages/businesses/online-payments/online-transactions/online-transactions.component";
import { RazorpayAccountIdAddComponent } from "./pages/businesses/online-payments/razorpay-account-id-add/razorpay-account-id-add.component";
import { EmployeesComponent } from "./pages/businesses/employees/employees.component";
import { BookingsComponent } from "./pages/businesses/bookings/bookings.component";
import { BackTitleBarComponent } from "./shared/components/back-title-bar/back-title-bar.component";
import { LatestBusinessesComponent } from "./pages/dashboard/latest-businesses/latest-businesses.component";
import { EmployeeSubscriptionComponent } from "./shared/components/employee-subscription/employee-subscription.component";
import { ProfileLatestDeactivatedAccountsComponent } from "./shared/components/profile-latest-deactivated-accounts/profile-latest-deactivated-accounts.component";
import { PostProfileDetailsComponent } from "./shared/components/post-profile-details/post-profile-details.component";
import { ViewBusinessProfileComponent } from "./shared/components/view-business-profile/view-business-profile.component";
import { BlockUnblockReportedComponent } from "./pages/activity/block-unblock-reported/block-unblock-reported.component";
import { BlockUnblockUsersComponent } from "./pages/dashboard/block-unblock-users/block-unblock-users.component";
import { ReferralComponent } from "./pages/referral/referral.component";
import { AddFreeSubComponent } from "./pages/subscription/add-free-sub/add-free-sub.component";
import { ViewDetailsComponent } from "./pages/referral/view-details/view-details.component";
import { UnblockAccountsComponent } from "./pages/activity/unblock-accounts/unblock-accounts.component";
import { BlockedAccountsDetailsComponent } from "./shared/components/blocked-accounts-details/blocked-accounts-details.component";
import { QrCodesComponent } from "./pages/qr-codes/qr-codes.component";
import { UnUsedQRComponent } from "./pages/qr-codes/un-used-qr/un-used-qr.component";
import { LinkedQRComponent } from "./pages/qr-codes/linked-qr/linked-qr.component";
import { LinkQRComponent } from "./pages/businesses/link-qr/link-qr.component";
import { LatestMessagesComponent } from "./pages/dashboard/latest-messages/latest-messages.component";
import { LatestNotificationsComponent } from "./pages/dashboard/latest-notifications/latest-notifications.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { AllMessagesComponent } from "./pages/dashboard/all-messages/all-messages.component";
import { AllNotificationsComponent } from "./pages/dashboard/all-notifications/all-notifications.component";
import { SearchComponent } from "./pages/search/search.component";
import { PurchasedPlansComponent } from "./pages/purchased-plans/purchased-plans.component";
import { PrivacyPolictyComponent } from "./pages/privacy-policty/privacy-policty.component";
import { TermsOfServiceComponent } from "./pages/terms-of-service/terms-of-service.component";
import { InviteFriendsComponent } from "./pages/invite-friends/invite-friends.component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ExpensesComponent } from "./pages/businesses/expenses/expenses.component";
import { BookingHistoryComponent } from "./pages/businesses/booking-history/booking-history.component";
import { InventoryComponent } from "./pages/businesses/inventory/inventory.component";
import { PurchaseListComponent } from "./pages/businesses/purchase-list/purchase-list.component";
import { PostComponent } from "./pages/businesses/post/post.component";
import { FeedbackComponent } from "./pages/businesses/feedback/feedback.component";
import { FolowersComponent } from "./pages/businesses/folowers/folowers.component";
import { TaxandgstComponent } from "./pages/businesses/taxandgst/taxandgst.component";
import { DiscountsComponent } from "./pages/businesses/discounts/discounts.component";
import { QrCodeComponent } from "./pages/businesses/qr-code/qr-code.component";
import { CustomersComponent } from "./pages/businesses/customers/customers.component";
import { ReportsComponent } from "./pages/businesses/reports/reports.component";
import { PlanAndRenewComponent } from "./pages/businesses/plan-and-renew/plan-and-renew.component";
import { AddNewBookingComponent } from "./shared/components/add-new-booking/add-new-booking.component";
import { ManageBookingComponent } from "./shared/components/manage-booking/manage-booking.component";
import { AssignJobComponent } from "./shared/components/assign-job/assign-job.component";
import { InvoiceComponent } from "./shared/components/invoice/invoice.component";
import { CustomiseBookingComponent } from "./shared/components/customise-booking/customise-booking.component";
import { BookingDetailsComponent } from "./shared/components/booking-details/booking-details.component";
import { NumericOnlyDirective } from "./directive/numeric-only.directive";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { AddEditTaxGstComponent } from "./shared/components/add-edit-tax-gst/add-edit-tax-gst.component";
import { AddEditDiscountsComponent } from "./shared/components/add-edit-discounts/add-edit-discounts.component";
import { MatRadioModule } from "@angular/material/radio";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { AddEditOnlinePaymentComponent } from "./shared/components/add-edit-online-payment/add-edit-online-payment.component";
import { CreateNewBusinessComponent } from "./shared/components/create-new-business/create-new-business.component";
import { UploadBusinessImageComponent } from "./shared/components/upload-business-image/upload-business-image.component";
import { AddServiceTemplateItemComponent } from "./shared/components/add-service-template-item/add-service-template-item.component";
import { ViewMediaGalleryComponent } from "./shared/components/view-media-gallery/view-media-gallery.component";
import { ServiceTimingsComponent } from "./pages/businesses/service-timings/service-timings.component";
import { AddServiceTimingsComponent } from "./shared/components/add-service-timings/add-service-timings.component";
import { NgxMatTimepickerModule } from "ngx-mat-timepicker";
import { AddDocumentsComponent } from "./shared/components/add-documents/add-documents.component";
import { ViewDocumentsDetailsComponent } from "./shared/components/view-documents-details/view-documents-details.component";
import { CustomConfirmDialogComponent } from "./shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { CustomAlertDialogComponent } from "./shared/components/custom-alert-dialog/custom-alert-dialog.component";
import { RecordPaymentComponent } from "./shared/components/record-payment/record-payment.component";
import { HomeqrAvailableComponent } from "./shared/components/homeqr-available/homeqr-available.component";
import { ShopqrAvailableComponent } from "./shared/components/shopqr-available/shopqr-available.component";
import { ShopqrnotAvailableComponent } from "./shared/components/shopqrnot-available/shopqrnot-available.component";
import { HomeqrnotAvailableComponent } from "./shared/components/homeqrnot-available/homeqrnot-available.component";
import { PersonalProfileComponent } from "./pages/personal-profile/personal-profile.component";
import { RenewBusinessComponent } from "./shared/components/renew-business/renew-business.component";
import { PreviousEmployeesComponent } from "./pages/previous-employees/previous-employees.component";
import { EmployeeInvitationComponent } from "./pages/employee-invitation/employee-invitation.component";
import { EmployeeDetailsComponent } from "./pages/employee-details/employee-details.component";
import { AddNewEmployeeComponent } from "./shared/components/add-new-employee/add-new-employee.component";
import { RenewEmployeeComponent } from "./shared/components/renew-employee/renew-employee.component";
import { EmployeeSalaryComponent } from "./pages/employee-salary/employee-salary.component";
import { EmployeeSalarySettingsComponent } from "./pages/employee-salary-settings/employee-salary-settings.component";
import { EmployeePayCreditsComponent } from "./pages/employee-pay-credits/employee-pay-credits.component";
import { EmployeeDutyLogsComponent } from "./pages/employee-duty-logs/employee-duty-logs.component";
import { EmployeeSubscriptionAndRenewComponent } from "./pages/employee-subscription-and-renew/employee-subscription-and-renew.component";
import { AddNewCreditComponent } from "./shared/components/add-new-credit/add-new-credit.component";
import { AddEmployeeSalarySettingComponent } from "./shared/components/add-employee-salary-setting/add-employee-salary-setting.component";
import { AddEmployeeSalaryComponent } from "./shared/components/add-employee-salary/add-employee-salary.component";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { CreditDetailsComponent } from "./shared/components/credit-details/credit-details.component";
import { EmployeeInvitationDetailsComponent } from "./pages/employee-invitation-details/employee-invitation-details.component";
import { BookingListForInvoiceMergeComponent } from "./shared/components/booking-list-for-invoice-merge/booking-list-for-invoice-merge.component";
import { OwnerProfileComponent } from "./pages/owner-profile/owner-profile.component";
import { AddEditOwnerProfileComponent } from "./shared/components/add-edit-owner-profile/add-edit-owner-profile.component";
import { PhoneNumberChangeComponent } from "./pages/phone-number-change/phone-number-change.component";
import { ChangeNumberComponent } from "./shared/components/change-number/change-number.component";
import { PrivacySettingsComponent } from "./pages/privacy-settings/privacy-settings.component";
import { DeactivateAccountComponent } from "./shared/components/deactivate-account/deactivate-account.component";
import { CustomersAllBookingsComponent } from "./pages/businesses/customers-all-bookings/customers-all-bookings.component";
import { CustomersDueBookingsComponent } from "./pages/businesses/customers-due-bookings/customers-due-bookings.component";
import { PaymentIntimationComponent } from "./shared/components/payment-intimation/payment-intimation.component";
import { CustomerBookingDetailsComponent } from "./shared/components/customer-booking-details/customer-booking-details.component";
import { MessageFilterPipe } from "./shared/pipes/message-filter.pipe";
import { CustomContextMenuForChatThreadsComponent } from "./shared/components/custom-context-menu-for-chat-threads/custom-context-menu-for-chat-threads.component";
import { EmployeeChatComponent } from "./shared/components/employee-chat/employee-chat.component";
import { LoginPageComponent } from "./pages/login/login-page/login-page.component";
import { LoginFormComponent } from "./pages/login/login-form/login-form.component";
import { MatStepperModule } from "@angular/material/stepper";
import { InviteFriendsTextComponent } from "./shared/components/invite-friends-text/invite-friends-text.component";
import { CookiePolicyBannerComponent } from "./shared/components/cookie-policy-banner/cookie-policy-banner.component";
import { InventoryItemsComponent } from "./pages/inventory-items/inventory-items.component";
import { InventoryItemsForMiscComponent } from "./shared/components/inventory-items-for-misc/inventory-items-for-misc.component";
import { MiscTitleBarComponent } from "./shared/components/misc-title-bar/misc-title-bar.component";
import { InventoryItemsForPurchaseComponent } from "./shared/components/inventory-items-for-purchase/inventory-items-for-purchase.component";
import { AddOtherExpensesComponent } from "./shared/components/add-other-expenses/add-other-expenses.component";
import { AddFutureBookingsComponent } from "./shared/components/add-future-bookings/add-future-bookings.component";
import { SalesReportComponent } from "./pages/businesses/reports/sales-report/sales-report.component";
import { EmployeePerformanceReportComponent } from "./pages/businesses/reports/employee-performance-report/employee-performance-report.component";
import { ExpenditureReportComponent } from "./pages/businesses/reports/expenditure-report/expenditure-report.component";
import { EmployeeSalaryReportComponent } from "./pages/businesses/reports/employee-salary-report/employee-salary-report.component";
import { BookingsReportComponent } from "./pages/businesses/reports/bookings-report/bookings-report.component";
import { ServicePerformanceReportComponent } from "./pages/businesses/reports/service-performance-report/service-performance-report.component";
import { InvoicesReportComponent } from "./pages/businesses/reports/invoices-report/invoices-report.component";
import { OnlinePaymentsReportComponent } from "./pages/businesses/reports/online-payments-report/online-payments-report.component";
import { InventoryActivityReportComponent } from "./pages/businesses/reports/inventory-activity-report/inventory-activity-report.component";
import { PurchaseActivityReportComponent } from "./pages/businesses/reports/purchase-activity-report/purchase-activity-report.component";
import { ProfitAnalysisReportComponent } from "./pages/businesses/reports/profit-analysis-report/profit-analysis-report.component";
import { TaxCollectionReportComponent } from "./pages/businesses/reports/tax-collection-report/tax-collection-report.component";
import { LineChartComponent } from "./shared/components/charts/line-chart/line-chart.component";
import { InvoiceForReportComponent } from "./shared/components/invoice-for-report/invoice-for-report.component";
import { BarChartComponent } from "./shared/components/charts/bar-chart/bar-chart.component";
import { PublicPostsComponent } from "./pages/businesses/folowers/public-posts/public-posts.component";
import { PublicMediaComponent } from "./pages/businesses/folowers/public-media/public-media.component";
import { FollowerChatComponent } from "./shared/components/follower-chat/follower-chat.component";
import { FollowerReportAbuseComponent } from "./shared/components/follower-report-abuse/follower-report-abuse.component";
import { SalaryForExpenseComponent } from "./shared/components/salary-for-expense/salary-for-expense.component";
import { PlatformServicesComponent } from "./pages/platform-services/platform-services.component";
import { ShareComponent } from "./pages/share/share.component";
import { EllipsifyPipe } from "./shared/pipes/ellipsify.pipe";
import { CreateBusinessComponent } from "./pages/create-business/create-business.component";
import { SupportTicketComponent } from "./pages/businesses/support-ticket/support-ticket.component";
import { SupportTicketDetailsComponent } from "./pages/businesses/support-ticket-details/support-ticket-details.component";
import { RaiseSupportTicketComponent } from "./shared/components/raise-support-ticket/raise-support-ticket.component";
import { CreateNewBookingComponent } from "./shared/components/create-new-booking/create-new-booking.component";
import { CalenderDialogComponent } from "./shared/components/calender-dialog/calender-dialog.component";
import { NewJobDoneComponent } from "./shared/components/new-job-done/new-job-done.component";
import { ArrayToStrPipe } from "./shared/pipes/array-to-str.pipe";
import { ServicesToStrPipe } from "./shared/pipes/services-to-str.pipe";
import { EmployeeAssignForServiceComponent } from "./shared/components/employee-assign-for-service/employee-assign-for-service.component";
import { EmployeeAssignForCustomiseComponent } from "./shared/components/employee-assign-for-customise/employee-assign-for-customise.component";
import { CreateInvoiceComponent } from "./shared/components/create-invoice/create-invoice.component";
import { BusinessCouponsComponent } from "./pages/businesses/coupons/coupons.component";
import { PurchasedPlanComponent } from "./pages/new-v2-pages/purchased-plan/purchased-plan.component";
import { BusinessCreateComponent } from "./pages/new-v2-pages/business-create/business-create.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { HomeComponent } from "./pages/new-v2-pages/home/home.component";
import { NewLoginComponent } from "./pages/new-v2-pages/login/login.component";
import { NewDashboardComponent } from "./pages/new-v2-pages/new-dashboard/new-dashboard.component";
import { AllTodayBookingsComponent } from "./pages/new-v2-pages/dashboard-view-all/all-today-bookings/all-today-bookings.component";
import { NewBusinessDetailsComponent } from "./pages/new-v2-pages/new-business-details/new-business-details.component";
import { BusinessDetailsOwnersComponent } from "./pages/new-v2-pages/business-details-owners/business-details-owners.component";
import { EditBusinessDetailsComponent } from "./pages/new-v2-pages/new-v2-component/edit-business-details/edit-business-details.component";
import { NewUploadMediaComponent } from "./pages/new-v2-pages/new-v2-component/new-upload-media/new-upload-media.component";
import { EditServiceComponent } from "./pages/new-v2-pages/new-v2-component/edit-service/edit-service.component";
import { NewEditLocationComponent } from "./pages/new-v2-pages/new-v2-component/new-edit-location/new-edit-location.component";
import { NewShowallGalleryComponent } from "./pages/new-v2-pages/new-v2-component/new-showall-gallery/new-showall-gallery.component";
import { NewServicesComponent } from "./pages/new-v2-pages/new-services/new-services.component";
import { NewServiceHoursComponent } from "./pages/new-v2-pages/new-service-hours/new-service-hours.component";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { AuthInterceptor } from "./providers/auth.interceptor";
import { NewBookingComponent } from "./pages/new-v2-pages/booking/new-booking/new-booking.component";
import { NewShowAllComponent } from "./pages/new-v2-pages/booking/new-show-all/new-show-all.component";
import { NewEmployeesComponent } from "./pages/new-v2-pages/new-employees/new-employees.component";
import { UpcomingAppointmentsComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/upcoming-appointments/upcoming-appointments.component";
import { LatestPurchasesComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/latest-purchases/latest-purchases.component";
import { InventoryStatusComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/inventory-status/inventory-status.component";
import { EmployeeLogComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/employee-log/employee-log.component";
import { ExpenditureStatusComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/expenditure-status/expenditure-status.component";
import { TodaysBookingsComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/todays-bookings/todays-bookings.component";
import { DailyBookingGraphComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/graphs/daily-booking-graph/daily-booking-graph.component";
import { DailySalesGraphComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/graphs/daily-sales-graph/daily-sales-graph.component";
import { ExpenditureGraphComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/graphs/expenditure-graph/expenditure-graph.component";
import { SvgLoaderComponent } from "./shared/components/svg-loader/svg-loader.component";
import { NewEmployeeDetailsComponent } from "./pages/new-v2-pages/new-employee-details/new-employee-details.component";
import { NewRechargesComponent } from "./pages/new-v2-pages/new-recharges/new-recharges.component";
import { EmployeesPurchasedPlanComponent } from "./pages/new-v2-pages/employees-purchased-plan/employees-purchased-plan.component";
import { EmployeePlansListComponent } from "./pages/new-v2-pages/employee-plans-list/employee-plans-list.component";
import { NewAddNewEmployeeComponent } from "./pages/new-v2-pages/new-add-new-employee/new-add-new-employee.component";
import { AllUpcomingAppointmentsComponent } from "./pages/new-v2-pages/dashboard-view-all/all-upcoming-appointments/all-upcoming-appointments.component";
import { AllLatestPurchaseComponent } from "./pages/new-v2-pages/dashboard-view-all/all-latest-purchase/all-latest-purchase.component";
import { AllInventoryStatusComponent } from "./pages/new-v2-pages/dashboard-view-all/all-inventory-status/all-inventory-status.component";
import { AllEmployeeLogComponent } from "./pages/new-v2-pages/dashboard-view-all/all-employee-log/all-employee-log.component";
import { AllExpenditureComponent } from "./pages/new-v2-pages/dashboard-view-all/all-expenditure/all-expenditure.component";
import { LineChartForDashboardComponent } from "./pages/new-v2-pages/new-dashboard/dashboard-cards/graphs/line-chart-for-dashboard/line-chart-for-dashboard.component";
import { ServToStrPipe } from "./shared/pipes/serv-to-str.pipe";
import { NewProduceBillComponent } from "./pages/new-v2-pages/booking/new-produce-bill/new-produce-bill.component";
import { UploadLogoForBusinessComponent } from "./pages/new-v2-pages/new-v2-component/upload-logo-for-business/upload-logo-for-business.component";
import { NewCurrentPackRechargeComponent } from "./pages/new-v2-pages/new-current-pack-recharge/new-current-pack-recharge.component";
import { PurchasedPlanForRenewComponent } from "./pages/new-v2-pages/purchased-plan-for-renew/purchased-plan-for-renew.component";
import { PlansListForRenewComponent } from "./pages/new-v2-pages/plans-list-for-renew/plans-list-for-renew.component";
import { AddNewServiceForBusinessComponent } from "./pages/new-v2-pages/new-v2-component/add-new-service-for-business/add-new-service-for-business.component";
import { AddNewTemplateServiceForBusinessComponent } from "./pages/new-v2-pages/new-v2-component/add-new-template-service-for-business/add-new-template-service-for-business.component";
import { BusinessProfileComponent } from "./pages/new-v2-pages/business-profile/business-profile.component";
import { MessagePanelComponent } from "./pages/new-v2-pages/new-v2-component/message-panel/message-panel.component";
import { EmployeeCurrentPackRechargeComponent } from "./pages/new-v2-pages/employee-current-pack-recharge/employee-current-pack-recharge.component";
import { InvoiceForMainComponent } from "./pages/new-v2-pages/new-v2-component/invoice-for-main/invoice-for-main.component";
import { RecordPaymentForMainComponent } from "./pages/new-v2-pages/new-v2-component/record-payment-for-main/record-payment-for-main.component";
import { EmployeePurchasedPlanForRenewComponent } from "./pages/new-v2-pages/employee-purchased-plan-for-renew/employee-purchased-plan-for-renew.component";
import { EmployeePlansListForRenewComponent } from "./pages/new-v2-pages/employee-plans-list-for-renew/employee-plans-list-for-renew.component";
import { YoutubeEmbedVideoComponent } from "./pages/new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { SlotTimingsComponent } from "./pages/new-v2-pages/new-v2-component/slot-timings/slot-timings.component";
import { DecimalOnlyDirective } from "./directive/decimal-only.directive";
import { SelectBusinessCountryComponent } from "./shared/components/select-business-country/select-business-country.component";
import { ImageCropperComponent } from "./pages/new-v2-pages/new-v2-component/image-cropper/image-cropper.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { JoiningQueryListComponent } from "./pages/new-v2-pages/joining-query-list/joining-query-list.component";
import { CancelBookingNotesModalComponent } from "./shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import { InternationalTaxConfigurerComponent } from "./pages/new-v2-pages/new-v2-component/international-tax-configurer/international-tax-configurer.component";
import { JoiningInterestDetailsComponent } from "./pages/new-v2-pages/new-v2-component/joining-interest-details/joining-interest-details.component";
import { AddJoiningInterestComponent } from "./pages/new-v2-pages/new-v2-component/add-joining-interest/add-joining-interest.component";
import { AddJoiningInterestTimingsComponent } from "./pages/new-v2-pages/new-v2-component/add-joining-interest-timings/add-joining-interest-timings.component";
import { UpdateInterestStatusReplyComponent } from "./pages/new-v2-pages/new-v2-component/update-interest-status-reply/update-interest-status-reply.component";
import { AddJoiningQueryComponent } from "./pages/new-v2-pages/new-v2-component/add-joining-query/add-joining-query.component";
import { CreateInvoiceForFitnessComponent } from "./shared/components/create-invoice-for-fitness/create-invoice-for-fitness.component";
import { AddMemberComponent } from "./shared/components/add-member/add-member.component";
import { MemberViewDetailsComponent } from "./shared/components/member-view-details/member-view-details.component";
import { MembersComponent } from "./pages/businesses/members/members.component";
import { MembersAllPaymentsComponent } from "./pages/businesses/members-all-payments/members-all-payments.component";
import { MembersDuePaymentsComponent } from "./pages/businesses/members-due-payments/members-due-payments.component";
import { InvoiceForFitnessComponent } from "./shared/components/invoice-for-fitness/invoice-for-fitness.component";
import { ConfigureTaxGstComponent } from "./pages/new-v2-pages/configure-tax-gst/configure-tax-gst.component";
import { AddCustomerComponent } from "./shared/components/add-customer/add-customer.component";
import { CreateInvoiceForCustomersComponent } from "./shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { NgxPrintModule } from "ngx-print";
import { ConfigureOnlinePaymentComponent } from "./pages/new-v2-pages/configure-online-payment/configure-online-payment.component";
import { InvoiceShareByEmailComponent } from "./pages/new-v2-pages/new-v2-component/invoice-share-by-email/invoice-share-by-email.component";
import { RecordPaymentForFitnessComponent } from "./shared/components/record-payment-for-fitness/record-payment-for-fitness.component";
import { InvoiceForReportOnlyComponent } from "./shared/components/invoice-for-report-only/invoice-for-report-only.component";
import { ConfigureDiscountComponent } from "./pages/new-v2-pages/configure-discount/configure-discount.component";
import { CustomersViewDetailsComponent } from "./pages/new-v2-pages/new-v2-component/customers-view-details/customers-view-details.component";
import { AddEditDomesticTaxConfigComponent } from "./pages/new-v2-pages/new-v2-component/add-edit-domestic-tax-config/add-edit-domestic-tax-config.component";
import { AddEditInternationalTaxConfigComponent } from "./pages/new-v2-pages/new-v2-component/add-edit-international-tax-config/add-edit-international-tax-config.component";
import { AddNewTaxComponent } from "./pages/new-v2-pages/add-new-tax/add-new-tax.component";
import { SalaryDetailsComponent } from "./pages/new-v2-pages/new-v2-component/salary-details/salary-details.component";
import { EntityProductsComponent } from "./pages/new-v2-pages/entity-products/entity-products.component";
import { AddProductComponent } from "./pages/new-v2-pages/new-v2-component/add-product/add-product.component";
import { AddProductFromInventoryComponent } from "./pages/new-v2-pages/new-v2-component/add-product-from-inventory/add-product-from-inventory.component";
import { BillInvoiceTypeComponent } from "./pages/new-v2-pages/new-v2-component/bill-invoice-type/bill-invoice-type.component";
import { CreateInvoiceWithoutBookingComponent } from "./shared/components/create-invoice-without-booking/create-invoice-without-booking.component";
import { InvoiceForWithoutBookingComponent } from "./shared/components/invoice-for-without-booking/invoice-for-without-booking.component";
import { MemberDetailsComponent } from "./pages/new-v2-pages/member-details/member-details.component";
import { AttendanceMarkerComponent } from "./pages/new-v2-pages/new-v2-component/attendance-marker/attendance-marker.component";
import { MembershipReportComponent } from "./pages/businesses/reports/membership-report/membership-report.component";
import { ViewAttendanceComponent } from "./pages/new-v2-pages/view-attendance/view-attendance.component";
import { MarkAbsentComponent } from "./pages/new-v2-pages/new-v2-component/mark-absent/mark-absent.component";
import { PhoneCheckForMemberComponent } from "./pages/new-v2-pages/new-v2-component/phone-check-for-member/phone-check-for-member.component";
import { EnrolledMemberPhoneChangeComponent } from "./pages/new-v2-pages/new-v2-component/enrolled-member-phone-change/enrolled-member-phone-change.component";
import { ServicesForCustomisationPipe } from "./shared/pipes/services-for-customisation.pipe";
import { CustomSnackbarComponent } from "./shared/components/custom-snackbar/custom-snackbar.component";
import { CustomersViewDetailsComponentForDet } from "./pages/businesses/customers-view-details/customers-view-details.component";
import { CustomerAllPaymentsComponent } from "./pages/businesses/customer-all-payments/customer-all-payments.component";
import { AddBusinessPostComponent } from "./pages/new-v2-pages/new-v2-component/add-business-post/add-business-post.component";
import { StackedBarChartComponent } from "./shared/components/charts/stacked-bar-chart/stacked-bar-chart.component";
import { EmployeesProfileComponent } from "./pages/new-v2-pages/employees-profile/employees-profile.component";
import { NewEmployeeJobOfferComponent } from "./pages/new-v2-pages/new-v2-component/new-employee-job-offer/new-employee-job-offer.component";
import { EmployeeOnlyMySalaryComponent } from "./pages/new-v2-pages/employee-only-my-salary/employee-only-my-salary.component";
import { EmployeeOnlyMyCreditsComponent } from "./pages/new-v2-pages/employee-only-my-credits/employee-only-my-credits.component";
import { EmployeeOnlyMyAttendanceComponent } from "./pages/new-v2-pages/employee-only-my-attendance/employee-only-my-attendance.component";
import { EmployeeOnlySendMessageComponent } from "./pages/new-v2-pages/new-v2-component/employee-only-send-message/employee-only-send-message.component";
import { EmployeeOnlyInvitationDetailsComponent } from "./pages/new-v2-pages/employee-only-invitation-details/employee-only-invitation-details.component";
import { InvoiceShareByWhatsappComponent } from "./pages/new-v2-pages/new-v2-component/invoice-share-by-whatsapp/invoice-share-by-whatsapp.component";
import { AssignJobForMembersComponent } from "./shared/components/assign-job-for-members/assign-job-for-members.component";
import { BookingDetailsForMemberComponent } from "./shared/components/booking-details-for-member/booking-details-for-member.component";
import { AlertForEmailComponent } from "./shared/components/alert-for-email/alert-for-email.component";
import { AddExistingAccountComponent } from "./shared/components/add-existing-account/add-existing-account.component";
import { AutoLoginLoaderComponent } from "./shared/components/auto-login-loader/auto-login-loader.component";
import { TestComponent } from "./pages/new-v2-pages/test/test.component";
import { RouterModule } from "@angular/router";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getMessaging, provideMessaging } from "@angular/fire/messaging";
import { AppOnboardingComponent } from "./pages/new-v2-pages/app-onboarding/app-onboarding.component";
import { AppVersionCheckingComponent } from "./pages/new-v2-pages/app-version-checking/app-version-checking.component";
import { AppLoginComponent } from "./pages/new-v2-pages/app-login/app-login.component";
import { CarouselModule } from "ngx-owl-carousel-o";
import { AlertForMobileLogComponent } from "./shared/components/alert-for-mobile-log/alert-for-mobile-log.component";
import { EntityUnavailabilityComponent } from "./pages/new-v2-pages/entity-unavailability/entity-unavailability.component";
import { AddUnavailabilitySettingsComponent } from "./pages/new-v2-pages/new-v2-component/add-unavailability-settings/add-unavailability-settings.component";
import { AllTaskAddedComponent } from "./pages/new-v2-pages/dashboard-view-all/all-task-added/all-task-added.component";
import { AllTaskCompletedComponent } from "./pages/new-v2-pages/dashboard-view-all/all-task-completed/all-task-completed.component";
import { MeetingDataComponent } from "./pages/new-v2-pages/new-v2-component/meeting-data/meeting-data.component";
import { MeetingDataForAppointmentComponent } from "./pages/new-v2-pages/new-v2-component/meeting-data-for-appointment/meeting-data-for-appointment.component";
import { PaymentPurchaseRecordComponent } from "./pages/new-v2-pages/new-v2-component/payment-purchase-record/payment-purchase-record.component";
import { PayViaPaypalComponent } from "./shared/components/pay-via-paypal/pay-via-paypal.component";
import { AllCustomersComponent } from "./pages/new-v2-pages/all-customers/all-customers.component";
import { AllMembersComponent } from "./pages/new-v2-pages/all-members/all-members.component";
import { PromotionCampaignComponent } from "./pages/new-v2-pages/promotion-campaign/promotion-campaign.component";
import { BookingDetailsPageComponent } from "./pages/new-v2-pages/booking-details-page/booking-details-page.component";
import { MembershipBookingDetailsPageComponent } from "./pages/new-v2-pages/membership-booking-details-page/membership-booking-details-page.component";
import { CreatePromotionCampaignComponent } from "./pages/new-v2-pages/new-v2-component/create-promotion-campaign/create-promotion-campaign.component";
import { ShowTargetsComponent } from "./pages/new-v2-pages/new-v2-component/show-targets/show-targets.component";
import { TargetsListComponent } from "./pages/new-v2-pages/new-v2-component/targets-list/targets-list.component";
import { CopyLinkCompComponent } from "./pages/new-v2-pages/new-v2-component/copy-link-comp/copy-link-comp.component";
import { PaypalEmployeeSubscriptionPurchaseComponent } from "./pages/new-v2-pages/new-v2-component/paypal-employee-subscription-purchase/paypal-employee-subscription-purchase.component";
import { PaypalEntitySubscriptionPurchaseComponent } from "./pages/new-v2-pages/new-v2-component/paypal-entity-subscription-purchase/paypal-entity-subscription-purchase.component";
import { LinkInternationalOnlinePaymentDetailsComponent } from "./pages/new-v2-pages/new-v2-component/link-international-online-payment-details/link-international-online-payment-details.component";
import { CreateNewBookingFromListComponent } from "./shared/components/create-new-booking-from-list/create-new-booking-from-list.component";
import { AddJoiningInterestFromListComponent } from "./pages/new-v2-pages/new-v2-component/add-joining-interest-from-list/add-joining-interest-from-list.component";
import { ShareCustomerAppComponent } from "./pages/new-v2-pages/share-customer-app/share-customer-app.component";
import { TrackingItemsComponent } from "./pages/new-v2-pages/tracking-items/tracking-items.component";
import { TrackingItemsDetailsComponent } from "./pages/new-v2-pages/tracking-items-details/tracking-items-details.component";
import { AddTrackingItemsComponent } from "./pages/new-v2-pages/new-v2-component/add-tracking-items/add-tracking-items.component";
import { AddTrackingItemsDetailsComponent } from "./pages/new-v2-pages/new-v2-component/add-tracking-items-details/add-tracking-items-details.component";
import { LineChartForTrackersComponent } from "./pages/new-v2-pages/tracking-items/graphs/line-chart-for-trackers/line-chart-for-trackers.component";
import { AutoInvoicingSettingComponent } from "./pages/new-v2-pages/new-v2-component/auto-invoicing-setting/auto-invoicing-setting.component";
import { AccessControlComponent } from "./pages/new-v2-pages/access-control/access-control.component";
import { EditAccessComponent } from "./shared/components/edit-access/edit-access.component";
import { CalenderDialogForBookingComponent } from "./shared/components/calender-dialog-for-booking/calender-dialog-for-booking.component";
import { AdvancePaymentSettingComponent } from "./pages/new-v2-pages/new-v2-component/advance-payment-setting/advance-payment-setting.component";
import { InvoiceForAdvanceComponent } from "./shared/components/invoice-for-advance/invoice-for-advance.component";
import { CancelDeleteActivityForBookingAndInvoiceComponent } from "./shared/components/cancel-delete-activity-for-booking-and-invoice/cancel-delete-activity-for-booking-and-invoice.component";
import { CustomerWalletMoneyComponent } from "./pages/new-v2-pages/customer-wallet-money/customer-wallet-money.component";
import { AddWalletMoneyComponent } from "./pages/new-v2-pages/new-v2-component/add-wallet-money/add-wallet-money.component";
import { ServiceQueryDetailsPageComponent } from "./pages/new-v2-pages/new-v2-component/service-query-details-page/service-query-details-page.component";
import { AddReplyForServiceQueryComponent } from "./pages/new-v2-pages/new-v2-component/add-reply-for-service-query/add-reply-for-service-query.component";
import { MemberEditOptedServicePackagesComponent } from './shared/components/member-edit-opted-service-packages/member-edit-opted-service-packages.component';
import { MemberEditOptedTimingsComponent } from './shared/components/member-edit-opted-timings/member-edit-opted-timings.component';
import { MemberEditPersonalDataComponent } from './shared/components/member-edit-personal-data/member-edit-personal-data.component';
import { LoyaltyConfigurerComponent } from './pages/new-v2-pages/loyalty-configurer/loyalty-configurer.component';
import { RewardPointsComponent } from './pages/new-v2-pages/reward-points/reward-points.component';
import { PointConversionComponent } from './pages/new-v2-pages/new-v2-component/point-conversion/point-conversion.component';
import { PublicPostSettingsComponent } from './shared/components/public-post-settings/public-post-settings.component';
import { DomainMappingComponent } from './pages/new-v2-pages/new-v2-component/domain-mapping/domain-mapping.component';
import { ServiceReminderComponent } from './pages/new-v2-pages/service-reminder/service-reminder.component';
import { NewReminderComponent } from './pages/new-v2-pages/new-v2-component/new-reminder/new-reminder.component';
import { UnpaidInvoicesComponent } from './pages/new-v2-pages/new-dashboard/dashboard-cards/unpaid-invoices/unpaid-invoices.component';
import { AllUnpaidInvoicesComponent } from './pages/new-v2-pages/dashboard-view-all/all-unpaid-invoices/all-unpaid-invoices.component';
import { CustomerDetailsComponent } from './pages/new-v2-pages/customer-details/customer-details.component';
import { EnrollNewMemberComponent } from "./pages/new-v2-pages/enroll-new-member/enroll-new-member.component";
import { PhoneCheckForMemberFromLeftPanelComponent } from './pages/new-v2-pages/new-v2-component/phone-check-for-member-from-left-panel/phone-check-for-member-from-left-panel.component';
import { AddBusinessExternalLinksComponent } from './pages/new-v2-pages/new-v2-component/add-business-external-links/add-business-external-links.component';
import { AskBusinessRatingComponent } from './shared/components/ask-business-rating/ask-business-rating.component';
import { EditMemberMeetingInfoComponent } from './pages/new-v2-pages/new-v2-component/edit-member-meeting-info/edit-member-meeting-info.component';
import { EditMemberAddressComponent } from './pages/new-v2-pages/new-v2-component/edit-member-address/edit-member-address.component';

firebase.initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    CreateBusinessComponent,
    SupportTicketComponent,
    SupportTicketDetailsComponent,
    RaiseSupportTicketComponent,
    SidebarComponent,
    DashboardComponent,
    SupportComponent,
    SubscriptionComponent,
    ActivityComponent,
    PromotionComponent,
    ReportComponent,
    TitleBarComponent,
    StatCardsComponent,
    LoginComponent,
    NewLoginComponent,
    LatestUsersComponent,
    DataTableComponent,
    LatestCountryListComponent,
    LatestSupportRequestComponent,
    UnblockRequestComponent,
    AllUsersComponent,
    AllCountriesComponent,
    AllSupportRequestComponent,
    AllUnblockRequestComponent,
    UserProfileComponent,
    LatestAbuseReportComponent,
    LatestDeactivatedAccountComponent,
    AllAbuseReportComponent,
    AllDeactivatedAccountComponent,
    AllBusinessInfoComponent,
    AllEmployeeInfoComponent,
    AllTransactionInfoComponent,
    AdminPostComponent,
    BusinessPromotionComponent,
    TargetNotificationComponent,
    AdvertisersComponent,
    AdminPostCardComponent,
    AddAdminPostComponent,
    BusinessPromotionCardComponent,
    LoaderComponent,
    AddTargetNotificationComponent,
    LocationAutocompleteDirective,
    AddBuisnessPostComponent,
    CrouselComponent,
    AdminPostDetailsComponent,
    CouponsComponent,
    CouponsCardComponent,
    AddDiscountComponent,
    BusinessesComponent,
    DocumentsComponent,
    BusinessListComponent,
    ServicesComponent,
    DetailsComponent,
    DeactivateBusinessComponent,
    OnlinePaymentsComponent,
    CancelVerificationComponent,
    ServiceTemplatesComponent,
    PaymentsComponent,
    AddServiceComponent,
    StatusNotesComponent,
    AddServiceTemplatesComponent,
    EntityBusinessComponent,
    DisableComponent,
    DeactivateComponent,
    OnlineTransactionsComponent,
    RazorpayAccountIdAddComponent,
    EmployeesComponent,
    BookingsComponent,
    BackTitleBarComponent,
    LatestBusinessesComponent,
    EmployeeSubscriptionComponent,
    ProfileLatestDeactivatedAccountsComponent,
    PostProfileDetailsComponent,
    ViewBusinessProfileComponent,
    BlockUnblockReportedComponent,
    BlockUnblockUsersComponent,
    ReferralComponent,
    AddFreeSubComponent,
    ViewDetailsComponent,
    UnblockAccountsComponent,
    BlockedAccountsDetailsComponent,
    QrCodesComponent,
    UnUsedQRComponent,
    LinkedQRComponent,
    LinkQRComponent,
    LatestMessagesComponent,
    LatestNotificationsComponent,
    ProfileComponent,
    AllMessagesComponent,
    AllNotificationsComponent,
    SearchComponent,
    PurchasedPlansComponent,
    PrivacyPolictyComponent,
    TermsOfServiceComponent,
    InviteFriendsComponent,
    ExpensesComponent,
    BookingHistoryComponent,
    InventoryComponent,
    PurchaseListComponent,
    PostComponent,
    FeedbackComponent,
    FolowersComponent,
    TaxandgstComponent,
    DiscountsComponent,
    QrCodeComponent,
    CustomersComponent,
    ReportsComponent,
    PlanAndRenewComponent,
    AddNewBookingComponent,
    ManageBookingComponent,
    AssignJobComponent,
    InvoiceComponent,
    CustomiseBookingComponent,
    BookingDetailsComponent,
    NumericOnlyDirective,
    AddEditTaxGstComponent,
    AddEditDiscountsComponent,
    AddEditOnlinePaymentComponent,
    CreateNewBusinessComponent,
    UploadBusinessImageComponent,
    AddServiceTemplateItemComponent,
    ViewMediaGalleryComponent,
    ServiceTimingsComponent,
    AddServiceTimingsComponent,
    AddDocumentsComponent,
    ViewDocumentsDetailsComponent,
    CustomConfirmDialogComponent,
    CustomAlertDialogComponent,
    RecordPaymentComponent,
    HomeqrAvailableComponent,
    ShopqrAvailableComponent,
    ShopqrnotAvailableComponent,
    HomeqrnotAvailableComponent,
    PersonalProfileComponent,
    RenewBusinessComponent,
    PreviousEmployeesComponent,
    EmployeeInvitationComponent,
    EmployeeDetailsComponent,
    AddNewEmployeeComponent,
    RenewEmployeeComponent,
    EmployeeSalaryComponent,
    EmployeeSalarySettingsComponent,
    EmployeePayCreditsComponent,
    EmployeeDutyLogsComponent,
    EmployeeSubscriptionAndRenewComponent,
    AddNewCreditComponent,
    AddEmployeeSalarySettingComponent,
    AddEmployeeSalaryComponent,
    CreditDetailsComponent,
    EmployeeInvitationDetailsComponent,
    BookingListForInvoiceMergeComponent,
    OwnerProfileComponent,
    AddEditOwnerProfileComponent,
    PhoneNumberChangeComponent,
    ChangeNumberComponent,
    PrivacySettingsComponent,
    DeactivateAccountComponent,
    CustomersAllBookingsComponent,
    CustomersDueBookingsComponent,
    PaymentIntimationComponent,
    CustomerBookingDetailsComponent,
    MessageFilterPipe,
    CustomContextMenuForChatThreadsComponent,
    EmployeeChatComponent,
    LoginPageComponent,
    LoginFormComponent,
    InviteFriendsTextComponent,
    CookiePolicyBannerComponent,
    InventoryItemsComponent,
    InventoryItemsForMiscComponent,
    MiscTitleBarComponent,
    InventoryItemsForPurchaseComponent,
    AddOtherExpensesComponent,
    AddFutureBookingsComponent,
    SalesReportComponent,
    EmployeePerformanceReportComponent,
    ExpenditureReportComponent,
    EmployeeSalaryReportComponent,
    BookingsReportComponent,
    ServicePerformanceReportComponent,
    InvoicesReportComponent,
    OnlinePaymentsReportComponent,
    InventoryActivityReportComponent,
    PurchaseActivityReportComponent,
    ProfitAnalysisReportComponent,
    TaxCollectionReportComponent,
    LineChartComponent,
    InvoiceForReportComponent,
    BarChartComponent,
    PublicPostsComponent,
    PublicMediaComponent,
    FollowerChatComponent,
    FollowerReportAbuseComponent,
    SalaryForExpenseComponent,
    PlatformServicesComponent,
    ShareComponent,
    EllipsifyPipe,
    CreateNewBookingComponent,
    CalenderDialogComponent,
    NewJobDoneComponent,
    ArrayToStrPipe,
    ServicesToStrPipe,
    EmployeeAssignForServiceComponent,
    EmployeeAssignForCustomiseComponent,
    CreateInvoiceComponent,
    BusinessCouponsComponent,
    PurchasedPlanComponent,
    HomeComponent,
    NewDashboardComponent,
    AllTodayBookingsComponent,
    BusinessCreateComponent,
    NewBusinessDetailsComponent,
    BusinessDetailsOwnersComponent,
    EditBusinessDetailsComponent,
    NewUploadMediaComponent,
    EditServiceComponent,
    NewEditLocationComponent,
    NewShowallGalleryComponent,
    NewServicesComponent,
    NewServiceHoursComponent,
    NewBookingComponent,
    NewShowAllComponent,
    NewEmployeesComponent,
    UpcomingAppointmentsComponent,
    LatestPurchasesComponent,
    InventoryStatusComponent,
    EmployeeLogComponent,
    ExpenditureStatusComponent,
    TodaysBookingsComponent,
    DailyBookingGraphComponent,
    DailySalesGraphComponent,
    ExpenditureGraphComponent,
    SvgLoaderComponent,
    NewEmployeeDetailsComponent,
    NewRechargesComponent,
    EmployeesPurchasedPlanComponent,
    EmployeePlansListComponent,
    NewAddNewEmployeeComponent,
    AllUpcomingAppointmentsComponent,
    AllLatestPurchaseComponent,
    AllInventoryStatusComponent,
    AllEmployeeLogComponent,
    AllExpenditureComponent,
    LineChartForDashboardComponent,
    ServToStrPipe,
    NewProduceBillComponent,
    UploadLogoForBusinessComponent,
    NewCurrentPackRechargeComponent,
    PurchasedPlanForRenewComponent,
    PlansListForRenewComponent,
    AddNewServiceForBusinessComponent,
    AddNewTemplateServiceForBusinessComponent,
    BusinessProfileComponent,
    MessagePanelComponent,
    InvoiceForMainComponent,
    RecordPaymentForMainComponent,
    EmployeeCurrentPackRechargeComponent,
    EmployeePurchasedPlanForRenewComponent,
    EmployeePlansListForRenewComponent,
    YoutubeEmbedVideoComponent,
    SlotTimingsComponent,
    DecimalOnlyDirective,
    SelectBusinessCountryComponent,
    ImageCropperComponent,
    JoiningQueryListComponent,
    CancelBookingNotesModalComponent,
    InternationalTaxConfigurerComponent,
    JoiningInterestDetailsComponent,
    AddJoiningInterestComponent,
    AddJoiningInterestTimingsComponent,
    UpdateInterestStatusReplyComponent,
    AddJoiningQueryComponent,
    AddMemberComponent,
    MemberViewDetailsComponent,
    CreateInvoiceForFitnessComponent,
    MembersComponent,
    MembersAllPaymentsComponent,
    MembersDuePaymentsComponent,
    InvoiceForFitnessComponent,
    ConfigureTaxGstComponent,
    AddCustomerComponent,
    CreateInvoiceForCustomersComponent,
    ConfigureOnlinePaymentComponent,
    InvoiceShareByEmailComponent,
    RecordPaymentForFitnessComponent,
    InvoiceForReportOnlyComponent,
    ConfigureDiscountComponent,
    CustomersViewDetailsComponent,
    CustomersViewDetailsComponentForDet,
    AddEditDomesticTaxConfigComponent,
    AddEditInternationalTaxConfigComponent,
    AddNewTaxComponent,
    SalaryDetailsComponent,
    EntityProductsComponent,
    AddProductComponent,
    AddProductFromInventoryComponent,
    BillInvoiceTypeComponent,
    CreateInvoiceWithoutBookingComponent,
    InvoiceForWithoutBookingComponent,
    MemberDetailsComponent,
    AttendanceMarkerComponent,
    MembershipReportComponent,
    PhoneCheckForMemberComponent,
    ViewAttendanceComponent,
    MarkAbsentComponent,
    EnrolledMemberPhoneChangeComponent,
    ServicesForCustomisationPipe,
    CustomSnackbarComponent,
    CustomerAllPaymentsComponent,
    AddBusinessPostComponent,
    StackedBarChartComponent,
    EmployeesProfileComponent,
    NewEmployeeJobOfferComponent,
    EmployeeOnlyMySalaryComponent,
    EmployeeOnlyMyCreditsComponent,
    EmployeeOnlyMyAttendanceComponent,
    EmployeeOnlySendMessageComponent,
    EmployeeOnlyInvitationDetailsComponent,
    InvoiceShareByWhatsappComponent,
    AssignJobForMembersComponent,
    BookingDetailsForMemberComponent,
    AlertForEmailComponent,
    AddExistingAccountComponent,
    AutoLoginLoaderComponent,
    TestComponent,
    AppOnboardingComponent,
    AppVersionCheckingComponent,
    AppLoginComponent,
    AlertForMobileLogComponent,
    EntityUnavailabilityComponent,
    AddUnavailabilitySettingsComponent,
    AllTaskAddedComponent,
    AllTaskCompletedComponent,
    MeetingDataComponent,
    MeetingDataForAppointmentComponent,
    PaymentPurchaseRecordComponent,
    PayViaPaypalComponent,
    AllCustomersComponent,
    AllMembersComponent,
    PromotionCampaignComponent,
    BookingDetailsPageComponent,
    MembershipBookingDetailsPageComponent,
    CreatePromotionCampaignComponent,
    ShowTargetsComponent,
    TargetsListComponent,
    CopyLinkCompComponent,
    PaypalEmployeeSubscriptionPurchaseComponent,
    PaypalEntitySubscriptionPurchaseComponent,
    LinkInternationalOnlinePaymentDetailsComponent,
    CreateNewBookingFromListComponent,
    AddJoiningInterestFromListComponent,
    ShareCustomerAppComponent,
    TrackingItemsComponent,
    TrackingItemsDetailsComponent,
    AddTrackingItemsComponent,
    AddTrackingItemsDetailsComponent,
    LineChartForTrackersComponent,
    AutoInvoicingSettingComponent,
    AccessControlComponent,
    EditAccessComponent,
    CalenderDialogForBookingComponent,
    AdvancePaymentSettingComponent,
    InvoiceForAdvanceComponent,
    CancelDeleteActivityForBookingAndInvoiceComponent,
    CustomerWalletMoneyComponent,
    AddWalletMoneyComponent,
    ServiceQueryDetailsPageComponent,
    AddReplyForServiceQueryComponent,
    MemberEditOptedServicePackagesComponent,
    MemberEditOptedTimingsComponent,
    MemberEditPersonalDataComponent,
    LoyaltyConfigurerComponent,
    RewardPointsComponent,
    PointConversionComponent,
    PublicPostSettingsComponent,
    DomainMappingComponent,
    ServiceReminderComponent,
    NewReminderComponent,
    UnpaidInvoicesComponent,
    AllUnpaidInvoicesComponent,
    CustomerDetailsComponent,
    EnrollNewMemberComponent,
    PhoneCheckForMemberFromLeftPanelComponent,
    AddBusinessExternalLinksComponent,
    AskBusinessRatingComponent,
    EditMemberMeetingInfoComponent,
    EditMemberAddressComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    AngularFireAuthModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    // NgImageSliderModule,//no need
    MatAutocompleteModule,
    // GooglePlaceModule,//no need
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatTimepickerModule,
    MatStepperModule,
    MatExpansionModule,
    NgxMatSelectSearchModule,
    ImageCropperModule,
    NgxPrintModule,
    CarouselModule,
    provideMessaging(() => getMessaging()),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    FileOpener,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
